var exports = {
  "an": "ErrorFallback.module__errorFallbackContainer___UjEzan",
  "MU": "ErrorFallback.module__errorFallbackIcon___UjEzan",
  "S6": "ErrorFallback.module__errorFallbackContent___UjEzan",
  "jQ": "ErrorFallback.module__errorFallbackTitle___UjEzan",
  "Xu": "ErrorFallback.module__errorFallbackSubtitle___UjEzan",
  "Xq": "ErrorFallback.module__errorFallbackAccounts___UjEzan",
  "pF": "ErrorFallback.module__errorFallbackDescription___UjEzan",
  "sM": "ErrorFallback.module__errorFallbackActions___UjEzan",
};

module.exports = exports;
